import { useAction } from "@/hooks/shared";
import { getBenchmarkStatusHandler } from "@/services";

export const useBenchmarkStatus = () => useAction(getBenchmarkStatusHandler);
